import { cn } from '@/lib/utils.js';

export function WarrantyBadge({
  isWarranty,
  className,
}: {
  isWarranty?: boolean | null | undefined;
  className?: string;
}) {
  if (!isWarranty) return null;
  return (
    <span
      className={cn(
        'rounded-full bg-violet-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-violet-800',
        className,
      )}
      title="Warranty rework"
    >
      Warranty
    </span>
  );
}
